



import Vue from "vue";
import Component from "vue-class-component";
import { BButton } from "bootstrap-vue";

@Component({
    components: { BButton },
})
export default class Footer extends Vue {}
